import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Alert, Link } from '@/ui'

// TODO: Migrate to V2
import { UserTaxCalculation } from '@/featuresV1/Admin/UserTaxCalculations/userTaxCalculation.slice'

export const getIsTaxCalcIncomeHigh = (taxCalc?: UserTaxCalculation | null) =>
  Boolean(
    taxCalc?.annualizedTotalWIncomeInCents &&
      taxCalc?.annualizedTotalWIncomeInCents > 40000000
  )

export const HighEstimatesAlert = ({
  title,
  taxCalc,
}: {
  title: string
  taxCalc?: UserTaxCalculation | null
}) => {
  const isIncomeHigh = getIsTaxCalcIncomeHigh(taxCalc)

  if (!isIncomeHigh) {
    return null
  }

  // todo this text doesn't work with q4
  return (
    <div className="w-full">
      <Alert title={title} variant="warning" customIconName={regular('stars')}>
        If you’ve earned income outside of your practice, double-check that it’s
        entered as year-to-date (this is how much you’ve earned so far this
        year).{' '}
        <Link
          href="/taxes/quarterly/recalculate"
          variant="secondary"
          newPage={false}
        >
          Make Adjustments
        </Link>
      </Alert>
    </div>
  )
}
